'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccessToken = getAccessToken;

var _globals = require('./globals');

// Try to get access token from URL, env, local storage or config
function getAccessToken() {
  var accessToken = null;

  if (_globals.window.location) {
    var match = _globals.window.location.search.match(/access_token=([^&\/]*)/);
    accessToken = match && match[1];
  }

  if (!accessToken) {
    // Note: This depends on the bundler (e.g. webpack) inmporting environment correctly
    accessToken = process.env.MapboxAccessToken || process.env.MAPBOX_ACCESS_TOKEN; // eslint-disable-line
  }

  return accessToken || null;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9hY2Nlc3MtdG9rZW4uanMiXSwibmFtZXMiOlsiZ2V0QWNjZXNzVG9rZW4iLCJhY2Nlc3NUb2tlbiIsImxvY2F0aW9uIiwibWF0Y2giLCJzZWFyY2giLCJwcm9jZXNzIiwiZW52IiwiTWFwYm94QWNjZXNzVG9rZW4iLCJNQVBCT1hfQUNDRVNTX1RPS0VOIl0sIm1hcHBpbmdzIjoiOzs7OztRQUdnQkEsYyxHQUFBQSxjOztBQUhoQjs7QUFFQTtBQUNPLFNBQVNBLGNBQVQsR0FBMEI7QUFDL0IsTUFBSUMsY0FBYyxJQUFsQjs7QUFFQSxNQUFJLGdCQUFPQyxRQUFYLEVBQXFCO0FBQ25CLFFBQU1DLFFBQVEsZ0JBQU9ELFFBQVAsQ0FBZ0JFLE1BQWhCLENBQXVCRCxLQUF2QixDQUE2Qix3QkFBN0IsQ0FBZDtBQUNBRixrQkFBY0UsU0FBU0EsTUFBTSxDQUFOLENBQXZCO0FBQ0Q7O0FBRUQsTUFBSSxDQUFDRixXQUFMLEVBQWtCO0FBQ2hCO0FBQ0FBLGtCQUNFSSxRQUFRQyxHQUFSLENBQVlDLGlCQUFaLElBQWlDRixRQUFRQyxHQUFSLENBQVlFLG1CQUQvQyxDQUZnQixDQUdvRDtBQUNyRTs7QUFFRCxTQUFPUCxlQUFlLElBQXRCO0FBQ0QiLCJmaWxlIjoiYWNjZXNzLXRva2VuLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHt3aW5kb3d9IGZyb20gJy4vZ2xvYmFscyc7XG5cbi8vIFRyeSB0byBnZXQgYWNjZXNzIHRva2VuIGZyb20gVVJMLCBlbnYsIGxvY2FsIHN0b3JhZ2Ugb3IgY29uZmlnXG5leHBvcnQgZnVuY3Rpb24gZ2V0QWNjZXNzVG9rZW4oKSB7XG4gIGxldCBhY2Nlc3NUb2tlbiA9IG51bGw7XG5cbiAgaWYgKHdpbmRvdy5sb2NhdGlvbikge1xuICAgIGNvbnN0IG1hdGNoID0gd2luZG93LmxvY2F0aW9uLnNlYXJjaC5tYXRjaCgvYWNjZXNzX3Rva2VuPShbXiZcXC9dKikvKTtcbiAgICBhY2Nlc3NUb2tlbiA9IG1hdGNoICYmIG1hdGNoWzFdO1xuICB9XG5cbiAgaWYgKCFhY2Nlc3NUb2tlbikge1xuICAgIC8vIE5vdGU6IFRoaXMgZGVwZW5kcyBvbiB0aGUgYnVuZGxlciAoZS5nLiB3ZWJwYWNrKSBpbm1wb3J0aW5nIGVudmlyb25tZW50IGNvcnJlY3RseVxuICAgIGFjY2Vzc1Rva2VuID1cbiAgICAgIHByb2Nlc3MuZW52Lk1hcGJveEFjY2Vzc1Rva2VuIHx8IHByb2Nlc3MuZW52Lk1BUEJPWF9BQ0NFU1NfVE9LRU47IC8vIGVzbGludC1kaXNhYmxlLWxpbmVcbiAgfVxuXG4gIHJldHVybiBhY2Nlc3NUb2tlbiB8fCBudWxsO1xufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/utils/access-token.js
// module id = 2932
// module chunks = 0